import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import Form from "react-bootstrap/Form";
import CalendarIcon from "../../assets/icons/calendar.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import ScheduleIcon from "../../assets/icons/scheduling.svg2";
import {
  ScheduleType,
  useCreateOrUpdateScheduleMutation,
  useGetSchedulerByUuidQuery,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { InputGroup, Tab, Tabs } from "react-bootstrap";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import DatePicker from "react-datepicker";
import SchedulersList from "./SchedulersList";
import ScheduleEdit from "./ScheduleEdit";
import MyModal from "../Common/MyModal";

export default function ScheduleSettings({
  button,
  uuid,
  broadcasterUuid,
  projectUuid,
  triggerData,
}: {
  button?: React.ReactNode;
  uuid?: string;
  broadcasterUuid?: string;
  projectUuid?: string;
  triggerData?: any;
}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <button
        type="button"
        className="btn p-0 align-baseline text-start"
        onClick={handleShow}
      >
        {button || (
          <>
            <ScheduleIcon width={20} />
            <span className="p-2">SCHEDULE SEND</span>
          </>
        )}
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        contentClassName="bg-purple-gradient"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="">Schedule settings</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-1">
          <ScheduleSettingsForm
            uuid={uuid}
            broadcasterUuid={broadcasterUuid}
            projectUuid={projectUuid}
            triggerData={triggerData}
            handleClose={handleClose}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export function ScheduleSettingsForm({
  uuid,
  broadcasterUuid,
  projectUuid,
  triggerData,
  handleClose,
  showNewScheduleByDefault,
}: {
  uuid?: string;
  broadcasterUuid?: string;
  projectUuid?: string;
  triggerData?: any;
  handleClose?: () => void;
  showNewScheduleByDefault?: boolean;
}) {
  const [showNewSchedule, setShowNewSchedule] = useState(false);
  useEffect(() => {
    if (showNewScheduleByDefault) {
      setShowNewSchedule(showNewScheduleByDefault);
    }
  }, [showNewScheduleByDefault]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-3">
        <h4 className="fw-bold m-0">Schedules</h4>
        <button
          className="btn-colored p-2 rounded-2"
          onClick={() => setShowNewSchedule(true)}
        >
          Create new schedule
        </button>
      </div>
      <div className="text-secondary">
        The following schedules has been set up. Click on the schedule label to
        edit its settings.
      </div>
      <SchedulersList
        broadcasterUuid={broadcasterUuid}
        projectUuid={projectUuid}
      />
      <MyModal
        heading="Create new schedule"
        size="lg"
        show={showNewSchedule}
        onHide={() => setShowNewSchedule(false)}
      >
        {({ handleClose }) => (
          <ScheduleEdit
            broadcasterUuid={broadcasterUuid}
            projectUuid={projectUuid}
            uuid={uuid}
            triggerData={triggerData}
            onClose={handleClose}
            onSave={handleClose}
          />
        )}
      </MyModal>
    </>
  );
}
